import type { Field } from './fields';
import type { Member } from './member';

export enum GroupTitles {
  BLOG_WRITER = 'Blog Writer',
}

export type AccountData = {
  member: Member;
  fields: Field[];
  site?: {
    isSSOMandatory: boolean;
    memberProfileURL: string;
    enabledSocialConnections: string[];
    isAboutInstalled: boolean;
    showPublicSections?: boolean;
  };
};

export enum ServerErrorCode {
  UNAUTHENTICATED,
  PERMISSION_DENIED,
  UNAVAILABLE,
  INTERNAL,
  INVALID_ARGUMENT,
  INVALID_CUSTOM_FIELD_URL,
}
